module.exports = __webpack_public_path__ + "static/media/998647.9a3d8e7c.png";